module.exports = __webpack_public_path__ + "img/close.ab20f4b3.png";